import { Calendar } from "@/components/ui/calendar";
import { ptBR } from "date-fns/locale";
import { Loader2 } from "lucide-react";

const keyOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// summary: { "YYYY-MM-DD": { available, recommended } }
export const AvailabilityCalendar = ({ summary, loading, selected, onSelect, from, to }) => {
  const free = (d) => (summary[keyOf(d)]?.available || 0) > 0;
  const route = (d) => (summary[keyOf(d)]?.recommended || 0) > 0;
  return (
    <div className="rounded-lg border border-border relative" data-testid="pb-month-calendar">
      {loading && (
        <div className="absolute inset-0 z-10 bg-background/70 flex items-center justify-center text-xs text-muted-foreground gap-2" data-testid="pb-month-loading">
          <Loader2 className="h-4 w-4 animate-spin" /> Buscando dias livres…
        </div>
      )}
      <Calendar
        mode="single"
        locale={ptBR}
        selected={selected}
        onSelect={(d) => { if (d) onSelect(d); }}
        fromDate={from}
        toDate={to}
        showOutsideDays={false}
        disabled={(d) => d < from || d > to || !free(d)}
        modifiers={{ free, route }}
        modifiersClassNames={{
          free: "font-semibold text-primary bg-primary/15 hover:bg-primary/25",
          route: "bg-emerald-100 text-emerald-900 ring-1 ring-emerald-500 dark:bg-emerald-950/50 dark:text-emerald-200",
        }}
        classNames={{ day_selected: "!bg-primary !text-primary-foreground", day_today: "underline underline-offset-4" }}
        className="mx-auto w-fit"
      />
      <div className="flex flex-wrap gap-3 px-3 pb-3 text-[11px] text-muted-foreground">
        <span className="inline-flex items-center gap-1"><span className="h-3 w-3 rounded bg-primary/20" /> Com horário livre</span>
        <span className="inline-flex items-center gap-1"><span className="h-3 w-3 rounded bg-emerald-100 ring-1 ring-emerald-500" /> Encaixa na rota do técnico</span>
        <span className="inline-flex items-center gap-1"><span className="h-3 w-3 rounded bg-muted" /> Sem horário</span>
      </div>
    </div>
  );
};
